var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useMissionsTranslation, useShiftStorage } from '../../../../ui/hooks';
import { useMissionLocationStorage } from '../../../../ui/hooks/useStorage';
import { handleErrorSnackbar, showInfoSnackbar } from '@juvare/common-web-ui/SnackbarHelper';
import { useCallback } from 'react';
import { repeatShiftInDateRange } from '../utils/repeatShiftInDateRange';
import { useShiftWizardSteps } from './useShiftWizardSteps';
export const useCreateShift = ({ missionId }) => {
    const { t } = useMissionsTranslation();
    const shiftStorage = useShiftStorage();
    const missionLocationStorage = useMissionLocationStorage();
    const { shiftWizardSteps } = useShiftWizardSteps();
    if (!missionId) {
        throw new Error('Mission id is required');
    }
    const handleSubmit = useCallback((data) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        try {
            const shiftData = Object.assign(Object.assign({}, data), { missionId });
            let missionLocationId;
            if (shiftData.addNewLocation) {
                missionLocationId = (yield missionLocationStorage.post({
                    action: 'create',
                    data: Object.assign(Object.assign({}, shiftData.addNewLocation), { status: 'active' }),
                })).id;
                shiftData.checkInAddress = 'existingAddress';
                delete shiftData.addNewLocation;
            }
            const checkInAddressId = (_a = shiftData.checkInAddressId) !== null && _a !== void 0 ? _a : missionLocationId;
            if (!checkInAddressId) {
                return handleErrorSnackbar({
                    message: 'Check-in address is not defined',
                });
            }
            const response = yield shiftStorage.post({
                action: 'create',
                data: Object.assign(Object.assign({}, shiftData), { checkInAddressId }),
            });
            if (data.repeatShift) {
                yield shiftStorage.massCreate({
                    items: repeatShiftInDateRange(Object.assign(Object.assign({}, shiftData), { checkInAddressId })).map((massItem) => {
                        var _a;
                        return {
                            data: Object.assign(Object.assign(Object.assign(Object.assign({}, massItem.data), { addNewLocation: undefined, checkInAddress: 'existingAddress' }), (((_a = response.data) === null || _a === void 0 ? void 0 : _a.checkInAddressId)
                                ? {
                                    checkInAddressId: response.data.checkInAddressId,
                                }
                                : {})), { duplicatedShiftId: response.id }),
                        };
                    }),
                });
            }
            showInfoSnackbar({
                message: t('shifts.created'),
                autoHideDuration: 2000,
            });
            return response;
        }
        catch (e) {
            return handleErrorSnackbar(e);
        }
    }), [t, shiftStorage, missionId, missionLocationStorage]);
    const wizardConfig = {
        steps: shiftWizardSteps,
        title: t('shifts.addShifts'),
        submitButtonLabel: t('shifts.finishLabel'),
        closeWizardContent: t('wizard.closeWizardContentNew'),
        onSubmit: handleSubmit,
    };
    return {
        wizardConfig,
    };
};
